import CollectionList from './CollectionList';
import CollectionListContainer from './CollectionList.container';
export default CollectionListContainer(CollectionList);
//# sourceMappingURL=index.js.map